module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'id',
    },
    {
      name: '标签ID',
      value: 'tag_id',
    },
    {
      name: '枚举标签名称',
      value: 'tag_name',
    },
    {
      name: '枚举值名称',
      value: 'enum_name',
    },
    {
      name: '枚举值描述',
      value: 'enum_desc',
    },
    {
      name: '操作',
      width: 150,
      format: (row) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('el-button',
              {
                props: {
                  size: 'mini',
                  type: 'primary',
                },
                on: {
                  click: () => {
                    s.edit(row, row.id);
                  },
                },
              },
              '编辑'
            ),
            h('el-button',
              {
                props: {
                  size: 'mini',
                  type: 'danger',
                },
                on: {
                  click: () => {
                    s.delete(row.id);
                  },
                },
              },
              '删除'
            ),
          ]
        );
        return ele;
      },
    },
  ];
};
